import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
// import { ChatLayout } from './components/chat/ChatLayout'; // 已暂时屏蔽
import LoginPage from './pages/LoginPage';
import LandingPage from './pages/LandingPage';
import AdminLayout from './components/admin/AdminLayout';
import KnowledgePage from './pages/admin/KnowledgePage';
import KnowledgeDetailPage from './pages/admin/KnowledgeDetailPage';
import FaqPage from './pages/admin/FaqPage';
import UsersPage from './pages/admin/UsersPage';
import ModelConfigPage from './pages/admin/ModelConfigPage';
import DashboardPage from './pages/admin/DashboardPage';
import ConversationsPage from './pages/admin/ConversationsPage';
import { useAuthStore } from './stores/authStore';
// import WidgetPage from './pages/Widget'; // 已暂时屏蔽

/**
 * 路由守卫：未登录跳转到 /login
 */
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, checkAuth } = useAuthStore();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    checkAuth().finally(() => setChecking(false));
  }, [checkAuth]);

  if (checking) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <span style={{ color: '#71717a' }}>加载中...</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

function App() {
  useEffect(() => {
    /**
     * 应用初始化逻辑
     * 1. 确保匿名 ID 存在（必须先完成）
     * 2. 连接 WebSocket（在 anonymous_id 生成后）
     * 3. 后台异步加载会话列表
     */
    const initApp = async () => {
      try {
        // 动态导入以避免循环依赖
        const { useChatStore } = await import('./stores/chatStore');
        const chatStore = useChatStore.getState();

        // 1. 确保匿名 ID 存在（必须先完成）
        await chatStore.ensureAnonymousId();

        // 2. 连接 WebSocket（在 anonymous_id 生成后）
        chatStore.connect();

        // 3. 延迟加载会话列表（避免阻塞初始渲染）
        setTimeout(() => {
          chatStore.fetchSessions().catch(err => {
            console.warn('[App] 后台加载会话列表失败（非阻塞）:', err);
          });
        }, 500);
      } catch (error) {
        console.warn('[App] 初始化失败（非阻塞）:', error);
      }
    };

    initApp();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* 公开页面 */}
        <Route path="/login" element={<LoginPage />} />
        {/* 以下两个路由已暂时屏蔽，只保留 widget-plugin 入口 */}
        {/* <Route path="/chat" element={<ChatLayout />} /> */}
        {/* <Route path="/widget" element={<WidgetPage />} /> */}

        {/* 管理后台（需要登录） */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="knowledge" element={<KnowledgePage />} />
          <Route path="knowledge/:id" element={<KnowledgeDetailPage />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="faq" element={<FaqPage />} />
          <Route path="model" element={<ModelConfigPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="conversations" element={<ConversationsPage />} />
        </Route>

        {/* 默认宣传页面 */}
        <Route path="/" element={<LandingPage />} />

        {/* 未知路由跳转到宣传页 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
